import { useEffect, useState } from "react";
import { Breadcrumb, Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Api from "../../utils/api";

const ProfileDetails = () => {

    const { id } = useParams();
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const data = await Api.get('/profiles/' + id);
            setProfile(data);
        } catch (error) {
            console.error('Error al obtener los datos:', error);
        }
    };

    const save = () => {
        Api.post('/profiles/' + id, profile)
    }

    const updateProfile = (event) => {
        let { name, value } = event.target;

        if (name === 'isBackup' || name === 'status') {
            value = value === '1' ? true : false
        }

        setProfile((state) => ({
            ...state,
            [name]: value,
        }));
    };


    const presets = [
        'ultrafast',
        'superfast',
        'veryfast',
        'faster',
        'fast',
        'medium',
        'slow',
        'slower',
        'veryslow'
    ];

    const sizes = [
        { value: '1920x1080', label: 'Full HD (1080p)' },
        { value: '1280x720', label: 'HD (720p)' },
        { value: '854x480', label: 'SD++ (480p)' },
        { value: '768x432', label: 'SD+ (432p)' },
        { value: '640x360', label: 'SD (360p)' },
        { value: '512x288', label: 'LQ+ (288p)' },
        { value: '480x270', label: 'LQ (240p)' },


    ];

    if (!profile) {
        return (
            <></>
        )
    }

    return (
        <Form>

            <Breadcrumb className="mt-3">
                <Breadcrumb.Item href="#">Inicio</Breadcrumb.Item>
                <Breadcrumb.Item href="/profiles">Perfiles</Breadcrumb.Item>
                <Breadcrumb.Item active>Detalles de Perfil</Breadcrumb.Item>
            </Breadcrumb>

            <h3 className="mt-3">Perfil {profile.name}</h3>

            <Card className="mt-3">
                <Card.Header>
                    Video
                </Card.Header>
                <Card.Body>

                    <Form.Group>
                        <Row>
                            <Col md={2} sm={4} className="mb-4">
                                <Form.Label>Codec</Form.Label>
                                <Form.Select name="codecVideo" defaultValue={profile.codecVideo} onChange={updateProfile}>
                                    <option value="copy">Original</option>
                                    <option value="libx264">h264</option>
                                    <option value="libx265">h265</option>
                                </Form.Select>
                            </Col>


                            {profile.codecVideo !== 'copy' &&
                                <>
                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>Bitrate</Form.Label>
                                        <InputGroup>
                                            <Form.Control name="bitrateVideo" defaultValue={profile.bitrateVideo} onChange={updateProfile} />
                                            <InputGroup.Text>kbps</InputGroup.Text>
                                        </InputGroup>
                                    </Col>

                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>Min rate</Form.Label>
                                        <InputGroup>
                                            <Form.Control name="minRate" defaultValue={profile.minRate} onChange={updateProfile} />
                                            <InputGroup.Text>kbps</InputGroup.Text>
                                        </InputGroup>
                                    </Col>

                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>Max rate</Form.Label>
                                        <InputGroup>
                                            <Form.Control name="maxRate" defaultValue={profile.maxRate} onChange={updateProfile} />
                                            <InputGroup.Text>kbps</InputGroup.Text>
                                        </InputGroup>
                                    </Col>

                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>Buffer Size</Form.Label>
                                        <InputGroup>
                                            <Form.Control name="bufferSize" defaultValue={profile.bufferSize} onChange={updateProfile} />
                                            <InputGroup.Text>kbps</InputGroup.Text>
                                        </InputGroup>
                                    </Col>

                                    <Col md={2} sm={4} className="mb-4"></Col>

                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>CRF</Form.Label>
                                        <Form.Select name="crf" defaultValue={profile.crf} onChange={updateProfile}>
                                            <option key={0} value="">Original</option>
                                            {Array.from({ length: 52 }, (_, index) => (
                                                <option key={index + 1} value={index + 1}>
                                                    {index + 1}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Col>

                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>FPS</Form.Label>
                                        <Form.Select name="frameRate" defaultValue={profile.frameRate} onChange={updateProfile}>
                                            <option key={0} value="">Original</option>
                                            {Array.from({ length: 16 }, (_, index) => (
                                                <option key={index + 15} value={index + 15}>
                                                    {index + 15}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Col>

                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>Preset</Form.Label>
                                        <Form.Select name="preset" defaultValue={profile.preset} onChange={updateProfile}>
                                            {presets.map((velocidad) => (
                                                <option key={velocidad} value={velocidad}>
                                                    {velocidad}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Col>

                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>Resolucion</Form.Label>
                                        <Form.Select name="resolution" defaultValue={profile.resolution} onChange={updateProfile}>
                                            <option key={0} value={0}>Original</option>
                                            {sizes.map(({ value, label }) => (
                                                <option key={value} value={value}>
                                                    {label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Col>

                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>Aspecto</Form.Label>
                                        <Form.Select name="aspect" defaultValue={profile.aspect} onChange={updateProfile}>
                                            <option value="">Original</option>
                                            <option value="16:9">16:9</option>
                                            <option value="4:3">4:3</option>
                                        </Form.Select>
                                    </Col>
                                </>
                            }
                        </Row>


                    </Form.Group>

                </Card.Body>
            </Card>



            <Card className="mt-5">
                <Card.Header>
                    Audio
                </Card.Header>
                <Card.Body>

                    <Form.Group>

                        <Row>

                            <Col md={2} sm={4} className="mb-4">
                                <Form.Label>Codec</Form.Label>
                                <Form.Select name="codecAudio" defaultValue={profile.codecAudio} onChange={updateProfile}>
                                    <option value="copy">Original</option>
                                    <option value="aac">AAC</option>
                                    <option value="liblamemp3">MP3</option>
                                </Form.Select>
                            </Col>

                            {profile.codecAudio !== 'copy' &&
                                <>

                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>Bitrate</Form.Label>
                                        <InputGroup>
                                            <Form.Control name="bitrateAudio" defaultValue={profile.bitrateAudio} onChange={updateProfile} />
                                            <InputGroup.Text>kbps</InputGroup.Text>
                                        </InputGroup>
                                    </Col>

                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>VBR</Form.Label>
                                        <Form.Select name="vbr" defaultValue={profile.vbr} onChange={updateProfile}>
                                            <option value="0">Usar bitrate</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                        </Form.Select>
                                    </Col>

                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>Volumen</Form.Label>
                                        <Form.Select name="audioVolume" defaultValue={profile.audioVolume} onChange={updateProfile}>
                                            <option value="">Original</option>
                                            <option value="1.1">+1.1</option>
                                            <option value="1.2">+1.2</option>
                                            <option value="1.3">+1.3</option>
                                            <option value="1.4">+1.4</option>
                                            <option value="1.5">+1.5</option>
                                            <option value="1.6">+1.6</option>
                                            <option value="1.7">+1.7</option>
                                            <option value="1.8">+1.8</option>
                                            <option value="1.9">+1.9</option>
                                        </Form.Select>
                                    </Col>

                                    <Col md={2} sm={4} className="mb-4">
                                        <Form.Label>Perfil</Form.Label>
                                        <Form.Select name="profileAudio" defaultValue={profile.profileAudio} onChange={updateProfile}>
                                            <option value="">Original</option>
                                            <option value="aac_he">aac_he</option>
                                            <option value="aac_he_v2">aac_he_v2</option>
                                        </Form.Select>
                                    </Col>

                                </>
                            }
                        </Row>
                    </Form.Group>
                </Card.Body>
            </Card>

            {profile.codecVideo !== 'copy' &&
                <Card className="mt-5">
                    <Card.Header>
                        Info
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col>
                                <Form.Label>Nombre</Form.Label>
                                <Form.Control name="name" defaultValue={profile.name} onChange={updateProfile} />
                            </Col>
                            <Col>
                                <Form.Label>Marca de agua</Form.Label>
                                <Form.Control name="watermark" defaultValue={JSON.stringify(profile.watermark)} onChange={updateProfile} />
                            </Col>
                        </Row>

                    </Card.Body>
                </Card>
            }


            {/*
            <Card className="mt-5">
                <Card.Header>
                    Salida
                </Card.Header>
                <Card.Body>

                    <Form.Group>

                        <Row>

                            <Col md={2} sm={4} className="mb-4">
                                <Form.Label>Map</Form.Label>
                                <Form.Control defaultValue={profile.map} />
                            </Col>

                            <Col md={2} sm={4} className="mb-4">
                                <Form.Label>Marca de agua</Form.Label>
                                <Form.Control defaultValue={profile.watermark} />
                            </Col>


                            <Col md={2} sm={4} className="mb-4">
                                <Form.Label>Nombre</Form.Label>
                                <Form.Control defaultValue={profile.name} />
                            </Col>


                            <Col md={2} sm={4} className="mb-4">
                                <Form.Label>Status</Form.Label>
                                <Form.Select defaultValue={profile.status ? '1' : '0'}>
                                    <option value="1">Activo</option>
                                    <option value="0">Inactivo</option>
                                </Form.Select>
                            </Col>



                            <Col md={2} sm={4} className="mb-4">
                                <Form.Label>Backup</Form.Label>
                                <Form.Select defaultValue={profile.isBackup ? '1' : '0'}>
                                    <option value="1">Activo</option>
                                    <option value="0">Inactivo</option>
                                </Form.Select>
                            </Col>
                        </Row>
                    </Form.Group>
                </Card.Body>
            </Card>
                                    */}

            <Row>
                <Col md={12} className="text-end mt-4">
                    <Button onClick={save}>Guardar</Button>
                </Col>
            </Row>


        </Form>
    );
}

export default ProfileDetails;